module.exports = __webpack_public_path__ + "static/assets/3500014ad16be4c02b27d864d80d49b9.svg";